import { defineComponent as _defineComponent } from 'vue'


interface IProps {
  color?: string;
  colorBackground?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GraphIcon',
  props: {
    color: { type: String, required: false },
    colorBackground: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})